var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 63,
    viewBox: "0 0 102 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7913 6.73474H37.21V56.2653H64.7913V6.73474Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9615 31.5C38.9571 26.7298 40.0388 22.0212 42.1246 17.7306C44.2105 13.4399 47.2458 9.67978 51.0008 6.73471C46.3507 3.08214 40.7661 0.810669 34.8853 0.179905C29.0045 -0.450859 23.0647 0.58452 17.7449 3.16774C12.4251 5.75097 7.93992 9.7778 4.80199 14.788C1.66405 19.7981 0 25.5894 0 31.5C0 37.4106 1.66405 43.2019 4.80199 48.212C7.93992 53.2222 12.4251 57.249 17.7449 59.8323C23.0647 62.4155 29.0045 63.4509 34.8853 62.8201C40.7661 62.1893 46.3507 59.9179 51.0008 56.2653C47.2458 53.3202 44.2105 49.56 42.1247 45.2694C40.0388 40.9788 38.9571 36.2701 38.9615 31.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 31.5C102 37.4105 100.336 43.2018 97.1986 48.2119C94.0608 53.2221 89.5757 57.2489 84.2561 59.8322C78.9364 62.4154 72.9967 63.4508 67.1159 62.8201C61.2352 62.1893 55.6507 59.9179 51.0008 56.2653C54.7525 53.3172 57.7854 49.5565 59.8709 45.2665C61.9564 40.9765 63.0401 36.2694 63.0401 31.5C63.0401 26.7306 61.9564 22.0234 59.8709 17.7335C57.7854 13.4435 54.7525 9.68275 51.0008 6.73471C55.6507 3.08214 61.2352 0.810653 67.1159 0.179897C72.9967 -0.450859 78.9364 0.584565 84.2561 3.16782C89.5757 5.75107 94.0608 9.7779 97.1986 14.7881C100.336 19.7982 102 25.5895 102 31.5Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9927 51.0193V50.0052H99.4019V49.7986H98.3598V50.0052H98.7691V51.0193H98.9927ZM101.016 51.0193V49.7966H100.696L100.329 50.6376L99.9615 49.7966H99.6419V51.0193H99.8674V50.097L100.212 50.8921H100.446L100.79 50.095V51.0193H101.016Z",
    fill: "#F79E1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.5a9904e2ffb0745a5a0ebd052f7e5b7e.svg";
export { ForwardRef as ReactComponent };